















































import {mapActions, mapGetters} from 'vuex';
import vue from 'vue';
import RichTextEditor from '@/components/admin/RichTextEditor.vue';

interface ComponentData {
  author: {
    email: string;
    firstName: string;
    lastLogin: Date | null;
    lastName: string;
    name: string;
    profileUrl: string;
    username: string;
  },
  dialog: {
    displayed: boolean;
    message: string;
  };
}

export default vue.extend({
  name: 'AdvertAdmin',
  components: {RichTextEditor},
  data: (): ComponentData => ({
    author: {
      email: '',
      firstName: '',
      lastLogin: null,
      lastName: '',
      name: '',
      profileUrl: '',
      username: '',
    },
    dialog: {
      displayed: false,
      message: '',
    },
  }),

  computed: {
    ...mapGetters([
      'advert',
      'authorProfile',
      'isAdmin',
      'profile',
    ]),
    humanDate(): string {
      return this.author.lastLogin
          ? `Dernière connexion le ${this.author.lastLogin.toLocaleDateString()} à ${this.author.lastLogin.toLocaleTimeString()}`
          : '';
    },
  },
  watch: {
    advert: function () {
      if (this.advert.author.id !== null) {
        this.loadAuthorProfile(this.advert.author)
            .then(() => {
              this.author = Object.assign({}, this.authorProfile);
            });
      }
    },
  },
  methods: {
    ...mapActions([
      'loadAuthorProfile',
      'moderateAdvert',
      'sendUserMessage',
    ]),
    onModerateAdvert() {
      if (this.dialog.message !== '') {
        this.sendUserMessage({
          adminId: this.profile.id,
          authorId: this.authorProfile.id,
          message: this.dialog.message,
        })
            .then(() => {
              this.moderateAdvert(this.advert);
            });
      } else {
        this.moderateAdvert(this.advert);
      }
    },
  },
});
